import React from "react";
import MyVoucher from "./MyVoucher";

interface VoucherList {
    onExchangeNow?: () => void;
}

export default function VoucherList({
    onExchangeNow,
}: VoucherList) {
    return (
        <div
            className="MuiGrid-root styles_promoContent_wrap__hmZtc MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12"
            style={{ padding: "10px 8px", backgroundColor: "rgb(244, 247, 252)" }}
        >
            <div className="MuiGrid-root styles_promoTitle__Nprix">
                <p className="MuiTypography-root MuiTypography-body1">
                    Danh sách mã giảm giá
                </p>
            </div>

            <MyVoucher />

            <div
                className="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center"
                style={{
                    display: "flex",
                    width: "100%",
                    marginTop: "10px",
                    marginRight: "4px",
                }}
            >
                <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-center MuiGrid-grid-xs-12">
                    <p
                        className="MuiTypography-root MuiTypography-body1"
                        style={{ fontFamily: "ggsm", padding: "10px" }}
                    >
                        Bạn chưa có mã giảm giá nào,{" "}
                        <a
                            role="presentation"
                            style={{
                                color: "var(--primary-color)",
                                cursor: "pointer",
                            }}
                            href="/users/loyalty_points"
                        >
                            đổi mã ngay.
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
}
